export const getToken = () => window.localStorage.getItem("token");